export default "__VITE_ASSET__BmNj8mYt__"